import { render, staticRenderFns } from "./open-modal.vue?vue&type=template&id=03e4b6fc"
import script from "./open-modal.vue?vue&type=script&lang=js"
export * from "./open-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports